export const retainVisibleSelectedIds = (selectedIds, visibleIds) => {
  const visibleIdSet = new Set(visibleIds);

  return selectedIds.filter((id) => visibleIdSet.has(id));
};
